import { render, staticRenderFns } from "./NominadosIconos.vue?vue&type=template&id=3f65278d&"
import script from "./NominadosIconos.vue?vue&type=script&lang=js&"
export * from "./NominadosIconos.vue?vue&type=script&lang=js&"
import style0 from "./NominadosIconos.vue?vue&type=style&index=0&id=3f65278d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports